import React, { useState, useEffect, useCallback } from 'react';
import { Styles } from '../../../../config/design/styles';
import { defaultVariables } from '../../../../config';
import axios from 'axios';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Alert, AlertTitle, Typography, Button } from '@mui/material';
import { DoneAll } from '@mui/icons-material';
import { withStyles } from '@mui/styles';
import { connect } from 'trim-redux';
import { AlertSkeleton } from '../../loaders/AlertSkeleton';
import {getDisplayTime, translateKey} from '../../../../config/values';
import {Link} from "react-router-dom";
import clsx from "clsx";

const UnReadNotificationsInfinity = ({ classes, refresh }) => {
    const [notifications, setNotifications] = useState([]);
    const [nextPage, setNextPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [check, setCheck] = useState(false);
    const [loading, setLoading] = useState(false);
    const [initialLoad, setInitialLoad] = useState(false);

    const handleLoadMore = useCallback(async () => {
        if (loading) return;
        setLoading(true);

        const loginToken = localStorage.getItem('ACT');
        if (!loginToken) {
            setLoading(false);
            return;
        }

        try {
            const config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            const response = await axios.get(`${defaultVariables.url}/user/notifications/get?page=${nextPage}`, config);
            const { current_page, last_page, data } = response.data;

            setNotifications(prev => [...prev.filter(n => !data.some(d => d.id === n.id)), ...data]);
            setHasMore(current_page !== last_page);
            setNextPage(current_page + 1);
            setCheck(true);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }, [nextPage, loading]);

    useEffect(() => {
        if (!initialLoad) {
            handleLoadMore();
            setInitialLoad(true);
        }
    }, [initialLoad, handleLoadMore]);

    const makeAsRead = async () => {
        const loginToken = localStorage.getItem('ACT');
        if (!loginToken) return;

        try {
            const config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            const response = await axios.get(`${defaultVariables.url}/user/notifications/read`, config);
            setNotifications(response.data);
            refresh();
        } catch (error) {
            console.error(error);
        }
    };

    const makeSingleAsRead = async (id) => {
        const loginToken = localStorage.getItem('ACT');
        if (!loginToken) return;

        try {
            const config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            await axios.post(`${defaultVariables.url}/user/notifications/readSingle`, { id }, config);
            refresh();
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <div className="notifications-holder">
            {notifications.length > 0 && (
                <Button color="primary" startIcon={<DoneAll />} onClick={makeAsRead}>
                    {translateKey('markAsRead')}
                </Button>
            )}
            <div className="notifications-container">
                <InfiniteScroll
                    dataLength={notifications.length}
                    next={handleLoadMore}
                    hasMore={hasMore}
                    loader={Array.from({ length: 4 }).map((_, i) => <AlertSkeleton key={i} />)}
                >
                    {notifications.map((notification, index) => (
                        <div key={notification.id}>
                            <Link to={`${notification.data.link}`} onClick={() => makeSingleAsRead(notification.id)}>
                                <Alert className={classes.NotificationAlert} severity={notification.data.type}>
                                    <AlertTitle>{notification.data.title.length > 0 ? notification.data.title : null}</AlertTitle>
                                    <span>{notification.data.text}</span>
                                    <Typography className={clsx(classes.NotifcationText,"notification-time")}>{getDisplayTime(notification.created_at)}</Typography>
                                </Alert>
                            </Link>
                        </div>
                    ))}
                </InfiniteScroll>
            </div>

            {check && notifications.length === 0 && (
                <Typography className={classes.emptyNotification} color="textSecondary" variant="body2">
                    {translateKey('noNotifications')}
                </Typography>
            )}
        </div>
    );
};

const mapStateToProps = state => ({
    isAuth: state.isAuth,
    user: state.user,
    locale: state.locale,
});

export default withStyles(Styles)(connect(mapStateToProps)(UnReadNotificationsInfinity));